import AccountSelect from "../AccountSelect";
import { Button, Col, DatePicker, Divider, Form,
  Input, Row, Tooltip
} from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import BoolToggle from "../BoolToggle";



const TransferFields = (props) => {
  // Rendered inside the drawer's <Form>, so the instance is reachable without prop drilling.
  const form = Form.useFormInstance();

  const handleSwap = () => {
    const from = form.getFieldValue('transfer_from_account');
    const to = form.getFieldValue('transfer_to_account');
    form.setFieldsValue({ transfer_from_account: to, transfer_to_account: from });
  };

  return (
    <>
      <Row align="top">
        <Col span={11}>
          <Form.Item name="transfer_from_account" label="Iz računa">
            <AccountSelect />
          </Form.Item>
        </Col>

        <Col span={2}>
          {/* Empty label borrows antd's vertical-layout label spacing so the
              button lands on the same baseline as both selects. */}
          <Form.Item label=" " colon={false} style={{ textAlign: 'center' }}>
            <Tooltip title="Zamenjaj računa">
              <Button type="text" icon={<SwapOutlined />} onClick={handleSwap} />
            </Tooltip>
          </Form.Item>
        </Col>

        <Col span={11}>
          <Form.Item name="transfer_to_account" label="Na račun">
            <AccountSelect />
          </Form.Item>
        </Col>
      </Row>

      <Divider />

      <Row gutter={[12, 12]}>
        <Col span={12}>
          <Form.Item
            name="date_to_be_paid"
            label="Realizirano"
            rules={[{ required: true, message: 'Prosim vnesite datum plačila' }]}
            help={<small>Datum realizacije.</small>}
            >
            <DatePicker style={{ width: '100%' }} getPopupContainer={(trigger) => trigger.parentElement} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="is_paid" initialValue={false} label=" " colon={false}>
            <BoolToggle label="Plačano" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="is_issued" initialValue={false} label=" " colon={false}>
            <BoolToggle label="Izdano" />
          </Form.Item>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col span={24}>
          <Form.Item
            name="title"
            label="Naziv"
            initialValue={'Interni prenos'}
            rules={[{ required: true, message: 'Prosim vnesite naziv' }]}
          >
            <Input size="large" placeholder="Vnesite naziv" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default TransferFields;
